export default function (value: string, length: number) {
  if (!value || value.length <= length) return value;

  return `${value.substr(0, length)}...`;
}
